import Slider from '@material-ui/core/Slider';
import { Typography } from '@room-match/shared-ui-components';
import React, { useEffect, useRef, useState } from 'react';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { ls } from 'shared/utils/ls';
import {
  AdultSliderCont,
  MiddleThumb,
  ParentThumb,
  PlayingAgeCont,
  StyledRangeSlider,
} from './GeneralAppearance.styles';

interface Props {
  setVal: (number: number[]) => void;
  val: number[] | null;
  slim?: boolean;
}

const AdultSlider: React.FC<Props> = ({ setVal, val, slim }) => {
  const [defaultVal, setdefaultVal] = useState([
    val ? val[0] : 15,
    val ? (val[0] + val[1]) / 2 : 19,
    val ? val[1] : 110,
  ]);
  const [allowance, setAllowance] = useState(4);
  const railRef = useRef<HTMLDivElement>(null);
  const { width } = useWindowDimensions();
  const [firstload, setfirstload] = useState(true);
  const { getLS, setLS } = ls();
  const [marks, setmarks] = useState([
    {
      value: 15,
      label: '15',
    },

    {
      value: 110,
      label: '110',
    },
  ]);

  const getAllowance = (median: number) => {
    if (median >= 18 && median <= 26) {
      return 4;
    } else if (median >= 27 && median <= 35) {
      return 5;
    } else if (median >= 36 && median <= 45) {
      return 6;
    } else if (median >= 46 && median <= 55) {
      return 7;
    } else if (median >= 56 && median <= 70) {
      return 10;
    } else {
      return 15;
    }
  };

  const handleChange = (e: any, n: any) => {
    const min = n[0],
      median = n[1],
      max = n[2];

    if (min === defaultVal[0] && median === defaultVal[1] && max === defaultVal[2]) return;

    if (median < 19 || median > 95 || min >= median || max <= median) return;

    const allowance = getAllowance(median);
    setAllowance(allowance);
    if (median !== defaultVal[1]) {
      setdefaultVal([median - allowance, median, median + allowance]);
    } else {
      if (min < median - allowance || max > allowance + median) return;
      setdefaultVal([min, median, max]);
    }
    // setLS('median', median);
  };
  function AirbnbThumbComponent(props: any) {
    return (
      <ParentThumb {...props} middle={props['data-index'] === 1}>
        <span className="bar" />
        <MiddleThumb />
        <span className="bar" />
      </ParentThumb>
    );
  }

  useEffect(() => {
    if (firstload && val) {
      const median = (val[0] + val[1]) / 2;
      setdefaultVal([val[0], median, val[1]]);
      setAllowance(getAllowance(median));
      setfirstload(false);
    }
  }, [val, firstload]);

  useEffect(() => {
    //check equality of defaultVal and val
    if (val && val[0] === defaultVal[0] && val[1] === defaultVal[2]) return;
    setVal([defaultVal[0], defaultVal[2]]);
  }, [defaultVal]);

  return (
    <AdultSliderCont slim={slim || false}>
      <PlayingAgeCont style={{ flexDirection: slim ? 'column' : 'unset' }}>
        <Typography style={{ marginRight: 7 }}>Playing Age Range:</Typography>
        <Typography color="primary">
          {defaultVal[0]}-{defaultVal[2]} years old
        </Typography>
      </PlayingAgeCont>
      {width < 960 || slim ? (
        <Slider
          orientation={'vertical'}
          max={110}
          min={15}
          track="normal"
          value={defaultVal}
          marks={marks}
          //   defaultValue={defaultVal}
          onChange={handleChange as any}
        />
      ) : (
        <StyledRangeSlider
          ThumbComponent={AirbnbThumbComponent}
          max={110}
          min={15}
          track="normal"
          value={defaultVal}
          marks={marks}
          //   defaultValue={defaultVal}
          onChange={handleChange as any}
        />
      )}
    </AdultSliderCont>
  );
};

export default AdultSlider;
